import uniqueId from 'lodash.uniqueid'
import AttachmentEntity, {
  AttachmentEntityFactory,
  AttachmentPropsFactory,
  EmptyAttachmentEntityFactory
} from '~/modules/app/entities/attachment'
import CandidateVisaAttachment from '../network/schema/models/candidate.visa.attachment'
import CandidateVisaAttachmentSeed from '../network/schema/models/candidate.visa.attachment.seed'

export interface ICandidateVisaAttachmentProps extends CandidateVisaAttachment {}
export interface ICandidateVisaAttachmentSeed extends CandidateVisaAttachmentSeed {}

export default class CandidateVisaAttachmentEntity {
  private _props: ICandidateVisaAttachmentProps
  private attachmentEntity: AttachmentEntity
  private attachmentThumbnailEntity: AttachmentEntity | undefined

  constructor(props: ICandidateVisaAttachmentProps) {
    this._props = props

    if (this.props.attachment) {
      this.attachmentEntity = AttachmentEntityFactory(this.props.attachment)
    } else {
      this.attachmentEntity = EmptyAttachmentEntityFactory()
    }

    if (this.props.attachmentThumbnail) {
      this.attachmentThumbnailEntity = AttachmentEntityFactory(this.props.attachmentThumbnail)
    }
  }

  get props(): ICandidateVisaAttachmentProps {
    return this._props
  }

  get id(): number | undefined {
    return this.props.id
  }

  get candidateVisaId(): number {
    return this.props.candidateVisaId
  }

  set candidateVisaId(value: number) {
    this.props.candidateVisaId = value
  }

  get attachment(): AttachmentEntity {
    return this.attachmentEntity
  }

  set attachment(value: AttachmentEntity) {
    this.attachmentEntity = value

    this.props.attachment = value?.props
  }

  get attachmentThumbnail(): AttachmentEntity | undefined {
    return this.attachmentThumbnailEntity
  }

  set attachmentThumbnail(value: AttachmentEntity | undefined) {
    this.attachmentThumbnailEntity = value

    this.props.attachmentThumbnail = value?.props
  }

  get createdAt(): string {
    if (!this.props.createdAt) {
      const timestamp = Date.now().toString()
      this.props.createdAt = `${uniqueId(timestamp)}`
    }
    return this.props.createdAt
  }

  /**
   * Whether the item has a thumbnail file or not.
   */
  get hasThumbnail(): boolean {
    const hasValidThumbnail = !!this._props.attachmentThumbnail && !!this._props.attachmentThumbnail.url
    return hasValidThumbnail
  }

  /**
   * The text to set in the HTML alt attribute. Only applies to image files.
   */
  get alt(): string | undefined {
    // TODO
    return ''
  }
}

export const CandidateVisaAttachmentPropsFactory = (
  props?: Partial<ICandidateVisaAttachmentProps>
): ICandidateVisaAttachmentProps => {
  return {
    id: 0,
    candidateVisaId: 0,
    attachment: AttachmentPropsFactory(),
    ...props
  }
}

export const CandidateVisaAttachmentEntityFactory = (
  props?: Partial<ICandidateVisaAttachmentProps>
): CandidateVisaAttachmentEntity => {
  return new CandidateVisaAttachmentEntity(CandidateVisaAttachmentPropsFactory(props))
}
